<template>
    <div class="permisos">
        <div class="encabezado">
            <h6 class="mb-0">Módulos</h6>
        </div>
        <p class="sinInfo" v-if="!permisos[0]">Sin información</p>
        <details 
            :key="i"
            v-for="(tr, i) in permisos"
            v-else
        >
            <summary><strong>{{tr.modulo}}</strong></summary>
            <vs-row>
                <vs-col class="ml-auto" sm="12" lg="3">
                    <vs-input class="ml-auto" v-model="search[i]" placeholder="Buscar">
                        <template #icon>
                            <i class="fas fa-search"></i>
                        </template>
                    </vs-input>
                </vs-col>
            </vs-row>
            <vs-table>
                <template #thead>
                <vs-tr>
                    <vs-th>
                        <span>Módulo</span>
                    </vs-th>
                    <vs-th>
                        <span>Permiso</span>
                    </vs-th>
                    <vs-th>
                        <span>Descripción</span>
                    </vs-th>
                    <vs-th>
                        <span>Asginación</span>
                    </vs-th>
                </vs-tr>
                </template>
                <template #tbody>
                <vs-tr
                    :key="j"
                    v-for="(perm, j) in $vs.getSearch(tr.permisos, search[i])"
                    class="divisionLineasPadres"
                >
                    <vs-td>
                        <p class="mb-0">{{perm.name}}</p>
                    </vs-td>
                    <vs-td>
                        <p class="mb-0">{{perm.permission}}</p>
                    </vs-td>
                    <vs-td>
                        <p class="mb-0">{{perm.permission_name}}</p>
                    </vs-td>
                    <vs-td>
                        <vs-switch style="width: 50px;" success v-model="perm.checked" @input="getValorCheck(perm)">
                            <template #off>
                                <i class="fas fa-times" style="font-size: 0.7rem"></i>
                            </template>
                            <template #on>
                                <i class="fas fa-check" style="font-size: 0.7rem"></i>
                            </template>
                        </vs-switch>
                    </vs-td>
                </vs-tr>
                </template>
            </vs-table>
            <!-- <table class="tableModulo mt-3">
                <thead>
                    <tr>
                        <th class="encabezados">
                            <span>Módulo</span>
                        </th>
                        <th class="encabezados">
                            <span>Permiso</span>
                        </th>
                        <th class="encabezados">
                            <span>Descripción</span>
                        </th>
                        <th class="encabezados">
                            <span>Asginación</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        :key="j"
                        v-for="(perm, j) in tr.permisos"
                        class="divisionLineasPadres"
                    >
                        <td class="alinearTexto">
                            <p>{{perm.name}}</p>
                        </td>
                        <td class="alinearTexto">
                            <p>{{perm.permission}}</p>
                        </td>
                        <td class="alinearTexto">
                            <p>{{perm.permission_name}}</p>
                        </td>
                        <td class="alinearTexto">
                            <vs-switch style="width: 50px;" success v-model="perm.checked" @input="getValorCheck(perm)">
                                <template #off>
                                    <i class="fas fa-times"></i>
                                </template>
                                <template #on>
                                    <i class="fas fa-check"></i>
                                </template>
                            </vs-switch>
                        </td>
                    </tr>
                </tbody>
            </table> -->
        </details>
    </div>
</template>
<script>
import accesibilidad from '../../../../api/requests/accesibilidad'
export default {
    props: [
        'permisos'
    ],
    data:() => ({
    editActive: false,
    edit: null,
    editProp: '',
    search: [],
    allCheck: false,
    page: 1,
    max: 3,
    active: 0,
    checked: false,
    selected: [],
    force: 0
    }),
    methods:{
        async getValorCheck(valor){
            // const found = this.permisos.find(el => el.modulo == valor.father)
            // const arr = found.permisos.find(el => el.permission == valor.permission)
            try{
                const formData = new FormData()
                formData.append('role_id', valor.role_id)
                formData.append('permission_name', valor.permission)
                formData.append('action', valor.checked == false ? 'quitar' : 'asignar')
                const response = await accesibilidad.getValorCheck(formData)
                this.$emit('refreshTable')
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: 'Se ha cambiado el permiso en ' + valor.name
                })
            }
            catch(error){
                console.log(error)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Se produjo un error',
                    text: 'Favor de contactar al adminsitrador'
                })
            }
        },
        getBuscador(){
            const info = this.permisos
            info.forEach(i => {
                this.search.push('')
            })
        }
    },
    watch:{
        permisos(){
            this.getBuscador()
        }
    }
}
</script>

<style scoped>
.permisos details, .tableModulo{
    width: 100%;
}
.tableModulo tr th{
    background: #efefef;
    padding: 6px 10px;
}
.tableModulo tr th span{
    font-size: 12px;
}
.tableModulo tr td{
    font-size: 12px;
}
.alinearTexto{
    padding: 6px 10px;
    background: #fdfdfd !important;
}
.alinearTexto p{
    margin:0 !important;
}
.divisionLineasPadres:not(:last-child){
    border-bottom: 2px solid #ececec;
}
</style>
<style lang="scss" scoped>
.permisos{
    .encabezado{
        border-radius: 14px 14px 0 0;
        background: #F4F7F8;
        padding: 10px 12px;
    }
    .sinInfo{
        padding: 20px;
        text-align: center;
    }
    details{
        padding: 10px 12px;
    }
    details:not(:last-child){
        border-bottom: 2px solid #ececec;
    }
    details summary{
    font-size: 15px;
    }
}
</style>
<style>
.permisos div.vs-table-content > div.vs-table > table{
        margin: 0 auto !important;
        width: 98% !important;
}
</style>